import React from "react"

import { History } from "lucide-react"

import { Button } from "@/components/ui/button"

interface ShiftChangesButtonProps {
  open: boolean
  onClick: () => void
}

const ShiftChangesButton: React.FC<ShiftChangesButtonProps> = ({ open, onClick }) => {
  return (
    <Button
      type="button"
      variant={open ? "default" : "outline"}
      size="sm"
      onClick={onClick}
      className="h-8 shrink-0 px-2.5 text-xs"
    >
      <History className="mr-1.5 h-3.5 w-3.5" />
      {open ? "Hide Changes" : "Changes"}
    </Button>
  )
}

export default ShiftChangesButton
